import { string, object } from 'yup';

const schema = object().shape({
  email: string().email('invalidEmailAddress')
});

export default schema;